import {
  type Appointment,
  type ExtendedAppointment,
  type History,
  type Opportunity,
  type Task,
  type hfb,
} from "@repo/api";
import { assertUnreachable } from "@repo/utils";
import { type ActionType, createAction, getType } from "typesafe-actions";

type AppointmentModalStep = "VIEW" | "EDIT" | "MORE_ACTIONS";
type AppointmentModalLoadingState =
  | "UPDATING"
  | "DELETING"
  | "MOVING_APPOINTMENT"
  | "CANCELLING"
  | "NO_SHOW"
  | "ASSIGNING";

export interface AppointmentModalState {
  step: AppointmentModalStep;
  appointment?: ExtendedAppointment;
  opportunityId?: number;
  loading?: AppointmentModalLoadingState;
  updatedTask?: Task;
  historyEntries?: History[];
  updatedAppointment?: Appointment;
  project?: Opportunity;
  customer?: Customer;
  departments?: hfb[];
  context: "PROJECT" | "CALENDAR";
}

export type AppointmentModalStateActions = typeof appointmentModalStateActions;

export const appointmentModalStateActions = {
  setStep: createAction("SET_STEP")<AppointmentModalStep>(),
  setAppointment: createAction("SET_APPOINTMENT")<ExtendedAppointment>(),
  setOpportunityId: createAction("SET_OPPORTUNITY_ID")<number>(),
  setLoading: createAction("SET_LOADING")<
    AppointmentModalLoadingState | undefined
  >(),
  setUpdatedTask: createAction("SET_UPDATED_TASK")<Task | undefined>(),
  setUpdatedAppointment: createAction("SET_UPDATED_APPOINTMENT")<
    Appointment | undefined
  >(),
  setHistoryEntries: createAction("SET_HISTORY_ENTRIES")<History[]>(),
  setCustomer: createAction("SET_CUSTOMER")<Customer>(),
};

export function AppointmentModalStateReducer(
  state: AppointmentModalState,
  action: ActionType<AppointmentModalStateActions>
) {
  switch (action.type) {
    case getType(appointmentModalStateActions.setStep):
      return { ...state, step: action.payload };
    case getType(appointmentModalStateActions.setAppointment):
      return { ...state, appointment: action.payload };
    case getType(appointmentModalStateActions.setOpportunityId):
      return { ...state, opportunityId: action.payload };
    case getType(appointmentModalStateActions.setLoading):
      return { ...state, loading: action.payload };

    case getType(appointmentModalStateActions.setUpdatedTask):
      return { ...state, updatedTask: action.payload };
    case getType(appointmentModalStateActions.setUpdatedAppointment):
      return { ...state, updatedAppointment: action.payload };
    case getType(appointmentModalStateActions.setHistoryEntries):
      return { ...state, historyEntries: action.payload };
    case getType(appointmentModalStateActions.setCustomer):
      return { ...state, customer: action.payload };
  }
  assertUnreachable(action);
}
